<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical
        :headerTitle="mainData.__created__ ? '비상대피 안내도 관리 추가' : '비상대피 안내도 관리 상세'"
        :IsUseSearchRequirement="true"
        :IsUseInfo="true"
        device="web"
      >
        <template v-slot:SearchRequirement>
          <v-switch v-model="editingData.finalApply" :disabled="editingData.tbmApply">
            <template v-slot:label>
              <span class="ml-2 main_text--text switch-label" :key="editingData.finalApply">
                {{ editingData.finalApply ? '최종적용' : '  미적용' }}
              </span>
            </template>
          </v-switch>
        </template>
        <template v-slot:Info>
          <span v-if="editingData.tbmApply" class="error--text">안전점검회의(TBM)에 적용된 안내도는 수정할 수 없습니다.</span>
          <span v-else></span>
        </template>
        <template v-slot:body>
          <!-- v-form 시작 -->
          <v-form ref="form">
            <v-row no-gutters>
              <v-col cols="12">
                <div class="editor-label">비상대피 안내도 명</div>
                <v-text-field ref="clntId" v-model="editingData.guideMapNm" solo class="editor_bg" :rules="rules" :disabled="editingData.tbmApply" />
              </v-col>
              <v-col cols="12" class="mt-5">
                <div class="editor-label">비고</div>
                <v-textarea
                  ref="desc"
                  v-model="editingData.remark"
                  no-resize
                  solo
                  class="editor_bg"
                  auto-grow
                  :disabled="editingData.tbmApply"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="12" lg="12">
                <iFileManage
                  ref="detailFileUpload"
                  :targetId="targetId"
                  targetType="00006"
                  @onFileChanged="onFileChanged"
                  :fileExtension="allowedFileExtensions.join(',')"
                  :readOnly="editingData.tbmApply"
                />
              </v-col>
            </v-row>
          </v-form>
        </template>
      </i-card-vertical>
      <i-card-right :useBtnList="buttonUseList" @btnSave="btnSave()" @btnSearch="btnSearch(mainData)" @btnDelete="btnDelete()"
        ><template v-slot:customBtn>
          <i-icon-button color="btn_text" :text="'목록으로'" height="92px" :icon="'back'" @click="btnCancel()" :appendDivider="true"> </i-icon-button
        ></template>
      </i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import iFileManage from '@/components/esgCommon/iFileManage.vue'
import {
  getEmergencyGuideMapDetail,
  saveEmergencyGuideMap,
  deleteEmergencyGuideMap,
  checkApplyGuideMap,
} from '@/api/emergencyActionPlan/emergencyGuideMap.js'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    'i-card-top': iCardTop,
    'i-card-vertical': iCardVertical,
    iFileManage,
  },
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true
          return '필수입력 값입니다.'
        },
      ],
      buttonUseList: [
        'btnSearch', //조회
        'btnSave', //저장
        'btnDelete', //삭제
      ],
      editingData: {},
      mainData: {},
      fileList: [],
      targetId: '',
      allowedFileExtensions: ['.jpg', '.jpeg', '.png', '.pdf'],
    }
  },
  created() {},
  beforeMount() {},
  mounted() {
    if (!this.$route.params.data) {
      this.$router.go(-1)
      return
    }

    if (!this.$route.params.data.__created__) {
      this.mainData = this.$route.params.data
      this.btnSearch(this.mainData)
    }
  },
  watch: {},
  computed: {
    mobileTrigger: function () {
      return this.width < 800
    },
  },
  async activated() {
    if (this.$route.params.data) {
      this.mainData = this.$route.params.data
      if (this.mainData.__created__) {
        this.initializeData()
      } else {
        this.btnSearch(this.mainData)
      }
    }
  },
  methods: {
    initializeData() {
      this.editingData = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        guideMapNm: '',
        remark: '',
        finalApply: false,
        __created__: true,
      }
      this.targetId = ''
    },
    btnSearch(params) {
      this.targetId = params.clntId + '_' + params.writeDt + '_' + params.docNo

      this.openLoading()
      console.log('[request] getEmergencyGuideMapDetail()', params)

      getEmergencyGuideMapDetail(params, true)
        .then((response) => {
          this.editingData = response
          this.$refs.detailFileUpload.btnSearch()
          this.editingData.finalApply = this.editingData.finalApply == 'Y' ? true : false
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnSave() {
      checkApplyGuideMap([this.editingData])
        .then((response) => {
          if (response.success) {
            const validate = this.$refs.form.validate()

            if (!validate) {
              this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'info')
              return
            }

            this.vToastifyPrompt(
              this.$t('doSaveData'),
              'info',
              async (current) => {
                this.openLoading()
                let saveSuccess = false
                this.editingData.finalApply = this.editingData.finalApply ? 'Y' : 'N'
                saveEmergencyGuideMap([this.editingData], true)
                  .then((response) => {
                    if (response.success) {
                      saveSuccess = true
                      getEmergencyGuideMapDetail(response.map).then((response) => {
                        this.editingData = response
                        this.editingData.finalApply = this.editingData.finalApply == 'Y' ? true : false
                        this.mainData = this.editingData
                      })
                      this.targetId = response.map.clntId + '_' + response.map.writeDt + '_' + response.map.docNo
                      this.editingData.__created__ = false
                    }
                  })
                  .catch((error) => {
                    if (error.response && error.response.data) {
                      if (error.response.data.code == -6037) {
                        this.vSnackbar(error.response.data.msg, 'warn')
                        this.endLoading()
                      }
                    }
                  })
                  .finally(() => {
                    // 저장 성공시 첨부 파일처리 - 신규 문서 targetId 할당 받기 위해 finally로 위치 변경
                    if (saveSuccess && (this.fileList.insert || this.fileList.delete)) {
                      this.$refs.detailFileUpload.btnSave(this.fileList)
                      this.fileList = {
                        insert: [],
                        delete: [],
                      }
                    }
                    this.endLoading()
                  })
              },
              null,
              true
            )
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            if (error.response.data.code == -6037) {
              this.vSnackbar(error.response.data.msg, 'warn')
              this.endLoading()
            }
          }
        })
    },
    btnDelete() {
      if (this.editingData.__created__) {
        this.vToastifyPrompt(
          this.$t('삭제하시겠습니까?'),
          'info',
          (current) => {
            const toRouter = {
              name: 'EmergencyGuideMapManage',
              params: {
                search: true,
              },
            }
            this.$router.push(toRouter)
          },
          null,
          true
        )
        return
      }
      checkApplyGuideMap([this.editingData])
        .then((response) => {
          if (response.success) {
            this.vToastifyPrompt(
              this.$t('doDeleteData'),
              'info',
              async (current) => {
                this.openLoading('deleting')
                deleteEmergencyGuideMap([this.editingData], true)
                  .then((response) => {
                    if (response.success) {
                      //this.$refs.detailFileUpload.fileRemove(this.$refs.detailFileUpload.files)
                      this.endLoading()
                      const toRouter = {
                        name: 'EmergencyGuideMapManage',
                        params: {
                          search: true,
                        },
                      }
                      this.$router.push(toRouter)
                    }
                  })
                  .catch((error) => {
                    if (error.response && error.response.data) {
                      if (error.response.data.code == -6026) {
                        this.vSnackbar(error.response.data.msg, 'warn')
                      }
                    }
                  })
                  .finally(() => {
                    this.endLoading()
                  })
              },
              null,
              true
            )
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            if (error.response.data.code == -6037) {
              this.vSnackbar(error.response.data.msg, 'warn')
              this.endLoading()
            }
          }
        })
    },
    btnCancel() {
      this.vToastifyPrompt(this.$t('작성을 중지하고 이전 페이지로 이동하시겠습니까?'), 'info', async (current) => {
        const toRouter = {
          name: 'EmergencyGuideMapManage',
          params: {
            search: true,
          },
        }
        this.$router.push(toRouter)
        return
      })
    },
    onFileChanged(fileList) {
      this.fileList = fileList
    },
  },
}
</script>

<style lang="scss"></style>
